module.exports = __webpack_public_path__ + "static/media/iphone 11 banner3.a30448fe.jpg";